export default {
      id: "icon-user-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }